import { Text } from "@chakra-ui/react";

const Logo = ({ color = "ink.900", dotColor = "brand.500", fontSize = { base: '26px', md: '30px' }, ...rest }) => (
    <Text as="span" fontFamily="heading" fontWeight={800} fontSize={fontSize} letterSpacing="-0.02em"
          lineHeight={1} color={color} {...rest}>
        Evenado<Text as="span" color={dotColor}>.</Text>
    </Text>
);

export default Logo;
